import { useChatClass } from "../../theme";
import { Avatar } from "../Avatar";
import { Container, Description, Title } from "./styled";

export interface AssistantInfoProps {
  /** The title of the assistant */
  title: string;
  /** A short description of the assistant to help frame the conversation */
  description: string;
  /** An image URL that identifies the assistant, such as a brand icon */
  avatar: string;
}

interface AssistantInfoComponent extends React.FC<AssistantInfoProps> {
  Container: typeof Container;
  Title: typeof Title;
  Description: typeof Description;
}

/** This component displays introductory information about the assistant.
 * It will act as a placeholder before the conversation has started. */
const AssistantInfo: AssistantInfoComponent = ({
  title,
  description,
  avatar,
}: AssistantInfoProps) => {
  const chatClass = useChatClass();
  return (
    <Container className={chatClass("assistant-info")}>
      <Avatar size="large" avatar={avatar} />
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

AssistantInfo.Container = Container;
AssistantInfo.Title = Title;
AssistantInfo.Description = Description;

export { AssistantInfo };
